export default "__VITE_ASSET__CRHji_Zi__"